import {createAction, props} from '@ngrx/store';
import {FirmaDTO} from '../../../../../openapi/export-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';
import {IdentifierType} from './datev-wizard-get-firma.state';


export class DatevWizardGetFirmaActions {

  private static readonly prefix = '[Datev Wizard Get Firma]';

  public static getFirma = createAction(
    `${this.prefix} Get Firma`,
    props<{
      firmenId: string;
    }>(),
  );

  public static getFirmaSuccess = createAction(
    `${this.prefix} Get Firma Success`,
    props<{
      firmaDto: FirmaDTO;
    }>(),
  );

  public static getFirmaFailure = createAction(
    `${this.prefix} Get Firma Failure`,
    props<{
      firmenId: string,
      error: MappedHttpErrorResponse,
    }>(),
  );

  public static setFirma = createAction(
    `${this.prefix} Set Firma`,
    props<{
      firmenId?: string;
    }>(),
  );

  public static syncFirmaFromRoute = createAction(
    `${this.prefix} Sync Firma From Route`,
    props<{
      firmenId: string;
    }>(),
  );

  public static setFirmenUsedInThePast = createAction(
    `${this.prefix} Set Firmen Used In The Past`,
    props<{
      firmenUsedInThePast: FirmaDTO[];
    }>(),
  );

  public static addInvalidFirma = createAction(
    `${this.prefix} Add Invalid Firma`,
    props<{
      firmenId: string;
    }>(),
  );

  public static goToCaseSelection = createAction(
    `${this.prefix} Go to case selection`,
    props<{
      firmenId: string;
    }>(),
  );

  public static goToClientId = createAction(
    `${this.prefix} Go to client Id`,
    props<{
      firmenId: string;
    }>(),
  );

  public static continueWithFirma = createAction(
    `${this.prefix} Continue with Firma`,
    props<{
      firmenId: string;
    }>(),
  );

  public static selectIdentifierType = createAction(
    `${this.prefix} Select Identifier Type`,
    props<{
      identifierType: IdentifierType;
    }>(),
  );

  public static searchFirmaByBetriebsnummer = createAction(
    `${this.prefix} Search Firma By Betriebsnummer`,
    props<{
      betriebsnummer: number;
    }>(),
  );

  public static searchFirmaByFirmennummer = createAction(
    `${this.prefix} Search Firma By Firmennummer`,
    props<{
      firmennummer: number;
    }>(),
  );

  public static searchFirmaByPartnernummer = createAction(
    `${this.prefix} Search Firma By Partnernummer`,
    props<{
      partnernummer: number;
    }>(),
  );

  public static searchFirmaSuccess = createAction(
    `${this.prefix} Search Firma Success`,
    props<{
      results: FirmaDTO[];
    }>(),
  );

  public static searchFirmaFailure = createAction(
    `${this.prefix} Search Firma Failure`,
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );

  public static selectFirmaFromSearchResults = createAction(
    `${this.prefix} Select Firma From Search Results`,
    props<{
      firma: FirmaDTO;
    }>(),
  );

  public static clearSearchResults = createAction(
    `${this.prefix} Clear Search Results`,
  );

}
